module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-image/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Splintinvest","short_name":"Splintinvest","start_url":"/","background_color":"#292566","theme_color":"#292566","display":"minimal-ui","icon":"src/images/logo-sign.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"c7f44a1564b6fd0a609b2a7ba9155724"},
    },{
      plugin: require('../node_modules/gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[],"pixelId":"3950724921695612"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
